import React, { useEffect, useState } from 'react';
import {Button} from 'theme/Button';
import {trackClick} from 'utility/analytics';
import { XXL, LG, MD} from '@zendeskgarden/react-typography';
import {HelmetWrapper} from 'utility/DefaultMeta';
import Spinner from 'components/Spinner/Spinner';
import Alert from 'theme/Alert';
import PageViewWrapper from 'higherOrder/PageViewWrapper';
import { forEach, get, filter, shuffle } from 'lodash'
import { Redirect } from 'react-router';

import ChooseOurCompanyEquipment from 'components/ChooseOurCompany/ChooseOurCompanyEquipment';

import RelatedProductsSlider from 'components/RelatedProductsSlider/RelatedProductsSlider';

import ProductsStatusMessage from './components/ProductsStatusMessage/ProductsStatusMessage';
import KeyFeatures from './components/KeyFeatures/KeyFeatures';
import ProductSpecs from './components/ProductSpecs/ProductSpecs';
import ListingsHero from './components/ListingsHero/ListingsHero';

import {ProductsSectionHeader} from 'routes/Products/Products.styles.js'
import { Grid, Row, Col } from '@zendeskgarden/react-grid';

// import { addProductToWishlist } from 'state/products/actions';
import { variables } from 'theme/variables';
import { ProductsPage, ProductsSection, ProductsSectionInner
} from './Products.styles.js';

import { useQuery } from '@apollo/client';
import { GET_LISTING_DETAILS, GET_LISTINGS } from 'state/listings/gql';
import {openModal} from 'state/modals/actions';


const {
  spacing_md
} = variables;


const Listings = (props) => {
  const listingId = props.match.params.id;

  const relatedListings = useQuery(GET_LISTINGS);
  const { loading, error, data } = useQuery(GET_LISTING_DETAILS(listingId));
  const productDetails = get(data, 'Listing')
   
  const metadata = getMeta(productDetails);
  const user = {};

  const [relatedListingsShuffled, setShuffled] = useState()

  useEffect(() => {
    if (get(relatedListings, 'data.Listings')) {
      setShuffled(shuffle(filter(get(relatedListings, 'data.Listings'), (l) => l.id !== Number(listingId))))
    }
  }, [get(relatedListings, 'loading')])

  
  const productSlug = get(productDetails, 'listing_slug');
  const routeSlug = props.match.params.slug;

  const slugsMatch = productSlug && routeSlug !== productSlug ? false : true;

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [listingId]);


  function goTorequest() {
    trackClick('inquire', 'Submit RFQ', 'Listings');
    openModal({
      type: 'inquireFormModal'
    })
  }

  const status = get(productDetails, 'result.status');
  const isDeleted = status === 'deleted';

  return (
    <ProductsPage>
      {
        !slugsMatch && !get(props.location, 'state.fromInternal') ?
        <Redirect from={`/l/${routeSlug}/${listingId}`} to={`/l/${productSlug}/${listingId}`}/> : null
      }

      {
        productDetails ?
        <HelmetWrapper metadata={metadata} /> : null
      }

      {
        loading && !get(productDetails, 'id') ?
        <Spinner size="20px"/> : null
      }


      {
        error ?
        <ProductsSection>
          <ProductsSectionInner first={true}>
            <Alert style={{marginBottom: spacing_md}} small title={error} type="error"  />
          </ProductsSectionInner>
        </ProductsSection>  : null
      }

     
      {
        isDeleted ?
        <ProductsSection>
          <ProductsSectionInner>
            <ProductsStatusMessage status={status} />
          </ProductsSectionInner>
        </ProductsSection> : null
      }
      {
        productDetails && !isDeleted ?
        <div>
          <ProductsSection>
            <ProductsSectionInner first={!error} >
              <ListingsHero userId={get(user, 'user_id')} productDetails={productDetails}/>
            </ProductsSectionInner>
          </ProductsSection>

         
          <ProductsSection grey>
            <ProductsSectionInner>
              <KeyFeatures productDetails={productDetails}/>
            </ProductsSectionInner>
          </ProductsSection>
          
         
          <ProductsSection>
            <ProductsSectionInner>
              <ProductSpecs productDetails={productDetails}/>
            </ProductsSectionInner>
          </ProductsSection>

        </div> : null
      }

      <ProductsSection grey style={{padding: '100px 15px', marginTop: '50px', marginBottom: '60px'}}>
        <ProductsSectionInner style={{paddingTop: 0, paddingBottom: '0'}}>
          <Row alignCenter>
            <Col size={12} justifyCenter column>
              <ChooseOurCompanyEquipment />
            </Col>
          </Row>
        </ProductsSectionInner>
      </ProductsSection>


      {
          get(relatedListingsShuffled, 'length') ?
          <ProductsSection>
            <ProductsSectionInner>
              <Grid>
                <Row>
                  <Col>
                    <ProductsSectionHeader tag="h2" style={{fontSize: '26px', marginBottom: '10px'}} scaled bold>Other Machines You May Be Interested In</ProductsSectionHeader>
                    <MD paddingBottomLg light slate style={{maxWidth: '940px'}}>{(productDetails && productDetails.listing_name) || 'This Machine'} is a great machine, but MRT offers a wide range of highly perfomant machines that perform. If you do not see a particular machine you are interested in <MD blue link as="span" bold onClick={goTorequest}>Submit A Request.</MD> </MD>
                  </Col>
                </Row>
              </Grid>
              <RelatedProductsSlider maxSlides={5} fromInternal={true} data={relatedListingsShuffled} />
            </ProductsSectionInner>
          </ProductsSection> : null
        }


      <ProductsSection grey style={{marginTop: '50px'}}>
        <ProductsSectionInner>
          <Row alignCenter>
            <Col size={12} justifyCenter column>
              <MD center blue uppercase paddingBottomLg semibold>Invest With MRT</MD>
              <XXL as="h2" center bold>Providing Machines That Perform.</XXL>

              <LG as="h3" style={{maxWidth: '900px', margin: '0 auto'}} center scaled slate paddingTopLg paddingBottomLg light>
                We inspect every machine that we bring into inventory and if it passes our rigorous inspection then we <b style={{fontWeight: 'bold'}}>actually do the work</b> to bring that machine back up to OEM specifications so that it looks and performs like new. 
              </LG>
              <Row style={{margin: '0 auto', marginTop: '30px'}}>
                <Col size={12} sm="auto">
                  <Button onClick={goTorequest} pairButton size="large" spacingBottom primary>Request A Machine</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </ProductsSectionInner>
      </ProductsSection>
    
    </ProductsPage>
  )
}


function getMeta(productData) {
    if (!productData) {
      return null;
    }
    const image = get(productData, 'image', '');
    const title = `MRT: ${productData.listing_name}`
    const price = productData.price;
    const condition = 'Used - Good';
    const quantity = '1';
    const brand = get(productData, 'listing_brand')
    const status = productData.status || 'active';
    const description = productData.listing_description
    const meta = [];
    const properties = {
      title, 
      description,
      image
    };
    forEach(properties, (v, k) => {
      if (v) {
        meta.push({property: `og:${k}`, content: v});
        meta.push({name: `twitter:${k}`, content: v});
      }
    });
    meta.push({name: 'description', content: description});
    meta.push({name: 'robots', content: 'all'});

    const json = {
      '@context': 'http://schema.org/',
      '@type': 'product',
      name: title,
      description,
      image,
      model: productData.model,
      category: productData.listing_type,
      brand: {
        name: brand
      },
      offers: {
        '@type': 'Offer',
        price,
        availability: status === 'active' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
        priceCurrency: 'USD',
        inventoryLevel: quantity,
        itemCondition: condition,
      }
    };

    
    const script = [
      {type: 'application/ld+json', innerHTML: JSON.stringify(json, null, 2)}
    ];
    
    const link = [];
    return {title, meta, link, script};
  
}


export default PageViewWrapper(Listings, {pageName: 'Listings'});
